import PAPDetails from 'pap/containers/details';
import PAPBrief from 'pap/containers/brief';
import PAPReview from 'pap/containers/review';
import PAPPayment from 'pap/containers/payment';

/**
 * The PAP workflow utilises 4 components - one for each main phase of the PAP process:
 * - PAPDetails (the phase where you specify project settings - title, awards, etc. and optionally lazy-register
 * - PAPBrief (the phase where you describe your creative needs)
 * - PAPReview (all information you entered in one place with the possiblity to edit)
 * - PAPPayment (here you specify the payment method, pay and publish your project)
 *
 * This lets each component have each own logic that isn't superficially generalised over all
 * steps, making the code more complex.
 *
 * Navigation between steps relies on routing, so that refreshing a page or directing the user
 * to a certain step is possible.
 *
 * Details phase steps are hardcoded on the frontend because they don't change except for
 * inclusion/exclusion of the lazy-registration step and do not vary based on the project
 * sub-category.
 *
 * The Brief phase relies on the list of questions set on the project by the server during project
 * creation (the project is actually created when the details phase finishes).
 *
 * The Review step relies on the list of detail steps and brief questions for displaying all the
 * data.
 *
 * The Payment step is completely separate from the previous 3.
 *
 * Each of those components relies on the PAPBase component so that we can factor out common elements (Header, bottom navigation) and PAPQuestionPage that controls the visual aspect of the central area.
 *
 * One key idea behind how PAP is structured is to reuse components as much as possible and so each
 * type of widget is actually a Redux-Form field. We also have a bunch of components for displaying
 * data. That way we can use those components when initially entering data (PAPDetails, PAPBrief)
 * and when displaying that data (PAPReview, Project page). This simplifies the code and reduces
 * the maintenance burden.
 *
 * TODO: add a details view for existing projects /start-a-project/ID/details/step-name
 * TODO: set initial values for details
 * TODO: fix display of some fields on the review step
 * TODO: add checks for figuring out if all previous steps are valid and what's the latest step so that re-entry doesn't break the process
 * TODO: LATER: Store the details form in local storage until the project is saved on the server
 * TODO: Store the details in local storage so that we don't hit the server with updates on every step
 */

export { PAPDetails, PAPBrief, PAPReview, PAPPayment }



// WEBPACK FOOTER //
// ./pap/index.jsx